const windowLocation = typeof window !== 'undefined' ? window.location : null;

const getMarketFromQueryParam = (): undefined | string =>
  new URLSearchParams(windowLocation?.search).get('market')?.toLowerCase() ?? undefined;

const getMarketFromPathname = (): undefined | string =>
  windowLocation?.pathname
    .split('/')
    .filter((v) => !!v)[0]
    ?.toLowerCase?.();

export const MARKET = getMarketFromQueryParam() ?? getMarketFromPathname();
